export enum ApiRoutesMarketing {
  Contacts = "admin/marketing/contacts",
  SegmentsPreview = "admin/marketing/segments/preview",
  SegmentsResolve = "admin/marketing/segments/resolve",
  SegmentsPreviewRecipients = "admin/marketing/segments/preview-recipients",
  Templates = "admin/marketing/templates",
  TemplatesSync = "admin/marketing/templates/sync",
  Campaigns = "admin/marketing/campaigns",
  CampaignsEstimate = "admin/marketing/campaigns/estimate",
  Flows = "admin/marketing/flows",
  FlowsRun = "admin/marketing/flows/run",
  Dispatch = "admin/marketing/dispatch"
}
